import React from 'react';
import { ChakraProvider, theme, CSSReset } from '@chakra-ui/react';
import { Provider } from 'react-redux';
import configureStore from './redux/store';
import Routes from './routes';

function App() {
  const store = configureStore();
  return (
    <Provider store={store}>
      <ChakraProvider theme={theme}>
        <CSSReset />
        <Routes></Routes>
      </ChakraProvider>
    </Provider>
  );
}

export default App;
